"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageFromObj = void 0;
function pageFromObj(obj) {
    return {
        id: obj.id || '',
        url: obj.url || ''
    };
}
exports.pageFromObj = pageFromObj;
